// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReusableButton.module.css */
.MuiButtonBase-root.styledButton {
    background-color: #69319D;
    text-transform: none;
    color: #fff;
    font-weight: 400;
    border: none; 
    font-family: var(--font-family-primary);
    border-radius: 5px;
    height: 44px;
    min-height: 44px;
    padding: 0 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    line-height: 1.2;
}
.MuiButtonBase-root.styledButton:hover {
    background-color: #803eff;
}
.MuiButtonBase-root.styledButton:disabled {
    background-color: #262839;
    color: rgba(253, 252, 255, 0.3);
       pointer-events: none;
    cursor: not-allowed;
    gap: 0px;
    display: flex;
    gap: 10px;
    align-items: center;
}
.Mui-disabled.styledButton .buttonIcon .MuiSvgIcon-root {
    color: rgba(253, 252, 255, 0.3) !important;
}
.MuiButtonBase-root.styledButton:focus-visible {
    outline: none;
    offset: 0px;
}

.MuiButtonBase-root.nonStyledbtn {
    background-color: transparent;
    text-transform: none;
    color: #fff;
    padding: 0 20px;
    font-weight: 400;
    border: 0.5px solid #69319D; 
    font-family: var(--font-family-primary);
    border-radius: 5px;
    height: 44px;
    min-height: 44px;
    /* min-width: 140px;
    max-width: 100%; */
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1rem;
    line-height: 1.2;
}
.MuiButtonBase-root.nonStyledbtn:hover {
    background-color: transparent;
}
.MuiButtonBase-root.Mui-disabled.nonStyledbtn {
    background-color: #262847;
    color: rgba(253, 252, 255, 0.3);
        pointer-events: none;
    cursor: not-allowed;
}  
.MuiButtonBase-root.nonStyledbtn:focus-visible {
    outline: none;
    offset: 0px;
}
.buttonIcon{
    /* width: 100%; */
    height: 100%;
    display: flex;
    align-items: center;
}

@media (max-width: 600px) {
    .MuiButtonBase-root.styledButton,
    .MuiButtonBase-root.nonStyledbtn {
        min-width: 100px;
        font-size: 0.95rem;
        padding: 0 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/PrimaryButton/PrimaryButton.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,+BAA+B;OAC5B,oBAAoB;IACvB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB;sBACkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,+BAA+B;QAC3B,oBAAoB;IACxB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":["/* ReusableButton.module.css */\n.MuiButtonBase-root.styledButton {\n    background-color: #69319D;\n    text-transform: none;\n    color: #fff;\n    font-weight: 400;\n    border: none; \n    font-family: var(--font-family-primary);\n    border-radius: 5px;\n    height: 44px;\n    min-height: 44px;\n    padding: 0 17px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    box-sizing: border-box;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 1rem;\n    line-height: 1.2;\n}\n.MuiButtonBase-root.styledButton:hover {\n    background-color: #803eff;\n}\n.MuiButtonBase-root.styledButton:disabled {\n    background-color: #262839;\n    color: rgba(253, 252, 255, 0.3);\n       pointer-events: none;\n    cursor: not-allowed;\n    gap: 0px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n.Mui-disabled.styledButton .buttonIcon .MuiSvgIcon-root {\n    color: rgba(253, 252, 255, 0.3) !important;\n}\n.MuiButtonBase-root.styledButton:focus-visible {\n    outline: none;\n    offset: 0px;\n}\n\n.MuiButtonBase-root.nonStyledbtn {\n    background-color: transparent;\n    text-transform: none;\n    color: #fff;\n    padding: 0 20px;\n    font-weight: 400;\n    border: 0.5px solid #69319D; \n    font-family: var(--font-family-primary);\n    border-radius: 5px;\n    height: 44px;\n    min-height: 44px;\n    /* min-width: 140px;\n    max-width: 100%; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    box-sizing: border-box;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 1rem;\n    line-height: 1.2;\n}\n.MuiButtonBase-root.nonStyledbtn:hover {\n    background-color: transparent;\n}\n.MuiButtonBase-root.Mui-disabled.nonStyledbtn {\n    background-color: #262847;\n    color: rgba(253, 252, 255, 0.3);\n        pointer-events: none;\n    cursor: not-allowed;\n}  \n.MuiButtonBase-root.nonStyledbtn:focus-visible {\n    outline: none;\n    offset: 0px;\n}\n.buttonIcon{\n    /* width: 100%; */\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width: 600px) {\n    .MuiButtonBase-root.styledButton,\n    .MuiButtonBase-root.nonStyledbtn {\n        min-width: 100px;\n        font-size: 0.95rem;\n        padding: 0 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
